import React from 'react'
import {Link} from 'react-router-dom'
export const ChannelList = [
    {
      channel_name: "Web Dev Simplified",
      subscribers: "1.05M",
      domain: "Web Development",
      channel_logo:
        "https://yt3.ggpht.com/ytc/AMLnZu-PjRc81p0qP-ZPWxv8aY4k-4gFRzGEYs3HWbIQ=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/WebDevSimplified",
      profile_pic: "",
    },
    {
      channel_name: "Traversy Media",
      subscribers: "1.95M",
      domain: "Web Development",
      channel_logo:
        "https://yt3.ggpht.com/ytc/AMLnZu-fB-c8gczS81r-VBWgzndcSZgd1zGA2QcYfACHMg=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/TraversyMedia",
      profile_pic: "",
    },
    {
      channel_name: "Academind",
      subscribers: "820K",
      domain: "Web Development",
      channel_logo:
        "https://yt3.ggpht.com/ytc/AMLnZu_Uksjq0hZKO8HU1hqf8LTFE91m1CeiSOe__5L8BA=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/Academind",
      profile_pic: "",
    },
    {
      channel_name: "sentdex",
      subscribers: "1.05M",
      domain: "AI/ML",
      channel_logo:
        "https://yt3.ggpht.com/ytc/AMLnZu9n0HP5bHv4SdHlTioBOD3FSwULk-uFEAIxx1HbTw=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/c/sentdex/",
      profile_pic: "",
    },
    {
      channel_name: "Free Code Camp",
      subscribers: "6.50M",
      domain: "All Domains",
      channel_logo:
        "https://yt3.ggpht.com/ytc/AMLnZu9UWrGceKWaqm8AF89vuxrEt8MO3E59qOoQ785Lew=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/c/Freecodecamp",
      profile_pic: "",
    },
    {
      channel_name: "Computerphile",
      subscribers: "1.15M",
      domain: "Computer Fundamentals",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu9t_O-t59ENbOIRPvxvZcxEFd3lw77plMuFGAu6Lw=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/user/Computerphile",
      profile_pic: "",
    },
    {
      channel_name: "The New Boston",
      subscribers: "2.60M",
      domain: "Computer Fundamentals",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu8OByGsgirSfHbmWD8P6vXknx2fR-QjlutAFwvRKg=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/user/thenewboston",
      profile_pic: "",
    },
    {
      channel_name: "Abdul Bari",
      subscribers: "619K",
      domain: "Computer Fundamentals",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu-ZXxG5Inn009QLZsWXUCRhzhb9mVExAXzcMuXQ=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/channel/UCZCFT11CWBi3MHNlGf019nw",
      profile_pic: "",
    },
    {
      channel_name: "The Net Ninja",
      subscribers: "1M",
      domain: "Web Development",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu_vx2QaoABpOD1MFk3nvLibUr8EDUv_Z_xyvOAk6A=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/c/TheNetNinja",
      profile_pic: "",
    },
    {
      channel_name: "Programming With Mosh",
      subscribers: "1M",
      domain: "Web Development",
      channel_logo: "https://yt3.ggpht.com/tBEPr-zTNXEeae7VZKSZYfiy6azzs9OHowq5ZvogJeHoVtKtEw2PXSwzMBKVR7W0MI7gyND8=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/c/programmingwithmosh",
      profile_pic: "",
    },
    {
      channel_name: "Kunal Kushwaha",
      subscribers: "292K",
      domain: "DevOps",
      channel_logo: "https://yt3.ggpht.com/5DmhCHgf5_Z0pLIExGWI9_5jO7T8JNXH3ISTOcLo9NW8bpTlBk2xLkQ3dfhzL-V7V8PNcxsy=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/KunalKushwaha",
      profile_pic: "",
    },
    {
      channel_name: "Gate Smashers",
      subscribers: "1.06M",
      domain: "Higher Studies",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu_LhOHz5PA3kggEkJwnS5Mm98g-N2YDytLkMxV4_A=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/GateSmashers",
      profile_pic: "",
    },
    {
      channel_name: "Neso Academy",
      subscribers: "1.75M",
      domain: "Higher Studies",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu-IKrxloiUX0fNCVH6QqIjmTCSQ74CBvlotA00I=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/nesoacademy",
      profile_pic: "",
    },
    {
      channel_name: "Amazon Web Services",
      subscribers: "630K",
      domain: "Cloud Computing",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu-TeqYTUHtz5NM4fN0RbWTETgl4L-HHzTWV5X7nAnU=s176-c-k-c0x00ffffff-no-rj-mo",
      channel_link: "https://www.youtube.com/c/amazonwebservices",
      profile_pic: "",
    },
    {
      channel_name: "SimpliLearn",
      subscribers: "2.40M",
      domain: "AI/ML",
      channel_logo: "https://yt3.ggpht.com/ytc/AMLnZu9vk_jSZZqpKOw6TohZDkc4e2ekKVYPlcioQjttfQ=s88-c-k-c0x00ffffff-no-rj",
      channel_link: "https://www.youtube.com/c/SimplilearnOfficial",
      profile_pic: "",
    },
  ];


function YoutubeGuide() {
  return (
    <div>
<div className="bg-img w-full  p-10 ">
         <div className="w-[75%] min-h-[40vh] text-white mx-auto grid grid-cols-[5fr_7fr]">
            <div className="col w-full h-full flex justify-start items-center">
            <h1 className='font-bold text-4xl'>Youtube Guide</h1>
            </div>

            <div className="col w-full h-full flex justify-end items-center text-left">
            <p className='text-2xl text-white/70'>Get a curated list of youtube  required to atain the mastery by taking courses which are choosen by developers for the developers ..</p>
          
            </div>

        </div>
    </div>
   <div className="grid my-10 gap-5 w-[75%] mx-auto grid-cols-3">
{

ChannelList.map((ele)=>{
  
 return<a href={ele.channel_link}>
  <div className="card rounded-md w-full bg-img p-2.5  ">
  <div className="w-full text-white min-h-[20vh] flex p-5 backdrop-blur-md bg-black/20 rounded-md">
         <div className="w-16 bg-white flex justify-center items-center h-16 rounded-full">
          <img src={ele.channel_logo} className="w-16 h-16 rounded-full" alt="" />
         </div>
         <div className="block mx-5">
          <h1 className='font-bold'>{ele.channel_name}</h1>
          <h1 className='text-white/70'> {ele.domain}</h1>
          <h1 className='text-sm' >{ele.subscribers}</h1>

         </div>
       </div>
             
  </div>
    </a>

})

}

   </div>


    </div>
  )
}

export default YoutubeGuide